import React from 'react';

import { Text, Spinner } from '@chakra-ui/react';

import { Icon } from 'components/icon';

import Button, { ButtonProps } from './default';

interface TableActionButtonProps extends ButtonProps { icon: string, text: string }

export default function TableActionButton({ icon, text, ...rest }:TableActionButtonProps) {
  return (
    <Button
      h={30}
      bg="white"
      _hover={{ bg: 'gray.50' }}
      _active={{}}
      spinner={(
        <Spinner
          color="primary.default"
          size="sm"
        />
      )}
      {...rest}>
      <Text
        variant="xSmallBold"
        color="gray.500">
        {text}
      </Text>
      <Icon
        ml={2}
        size="xs"
        color="gray.500"
        family="fas"
        name={icon}
      />
    </Button>
  );
}
